import React, { useEffect, useState, useRef } from "react";
import { Grid, Box, Button, TextField, MenuItem, IconButton, Slider } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import AccessibleTable from "../component/table";
import { POS } from "../../../../constant/pos";
import { CustomBtn } from "../../../../components/button/button";
import dayjs from "dayjs";
import SuggestionInput from "../../../../components/suggestionInput/suggestionInput";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Date } from "../../../../components/Date/Date";
import { FullDate } from "../../../../components/Date/FullDate";
import CustomForm from "../../../../components/form/form";
import BillTable from "./table_bills";
import SupplierPaymentsTable from "./table_suplier_pays";
import ReturnTable from "./table_return_process";
// const categoryOptions = ["Antibiotics", "Pain Relievers", "Vitamins", "Antiseptics", "Allergy Medications"]; // Static category list
import { ShowLoader } from '../../../../redux/actions/loader';

const SupplierReturns = () => {
    const [data, setData] = useState(POS().Report.ReportProductPage);
    const api = useSelector((state) => state.Api);
    const [payAmount, setPayAmount] = useState(0);
    const [suggestions, setSuggestions] = useState([]);
    const [roznamcha, setRoznamcha] = useState([]);
    const [totalBilled, setTotalBilled] = useState(0);
    const [totalUnpaid, setTotalUnpaid] = useState(0);
    const [selectedSupplier, setSelectedSupplier] = useState();
    const [products, setProducts] = useState([]);
    const [roznamchBalance, setRoznamchBalance] = useState();//setRoznamchBalance
    const [todayIn, setTodayIn] = useState(0);
    const [suplierLoans, setSuplierLoans] = useState();
    const [showSupplier, setshowSupplier] = useState();
    const [currentSupplierPayInOut, setCurrentSupplierPayInOut] = useState(0);
    const dispatch = useDispatch();
    const [refreshKey, setRefreshKey] = useState(0);
    const [refreshLoan, setRefreshLoan] = useState(0);
    const initSup = useRef(false);

    const fetchSuppliers = async () => {
        if(initSup.current) return 
        initSup.current = true
        dispatch(ShowLoader('1'))
        const userToken = JSON.parse(localStorage.getItem("User_Data"))?.token || undefined;
        try {
            const response = await axios.get(api.showSupplier, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userToken}`,
                },
            });
            if (response.status === 200) {
                setSuggestions(response.data.data);
                const loansResponse = await fetchSupplierLoans(); // Wait for loans to fetch
                // Update showSupplier if we have a selected supplier
                if (selectedSupplier) {
                    const suppLoanAmount = loansResponse.filter((it) => it.supplier_id == selectedSupplier.supplier_id);
                    setshowSupplier(suppLoanAmount[0]);
                }
                dispatch(ShowLoader('0'))
            }
        } catch (err) {
            console.error("Error fetching suppliers:", err);
        }
    };

    const fetchSupplierLoans = async () => {
        dispatch(ShowLoader('1'))
        const userToken = JSON.parse(localStorage.getItem("User_Data"))?.token || undefined;
        try {
            const response = await axios.get(api.showSupplierDefault, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userToken}`,
                },
            });
            if (response.status === 200) {
                setSuplierLoans(response.data.data);
                return response.data.data; // Return the data
                dispatch(ShowLoader('0'))
            }
            return [];
        } catch (err) {
            console.error("Error fetching suppliers:", err);
            return [];
        }
    };

 
    useEffect(() => {
        fetchSuppliers()
        // fetchRoznamcha()
        // //console.log('use efffett---------------------')
        setSuplierLoans(suplierLoans)
        setshowSupplier({...showSupplier})
    }, [api.showSupplier, refreshKey]);

 
    const fetchProducts = async (id) => {
        dispatch(ShowLoader('1'))
        // //console.log(id)
        const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;

        try {
            const response = await axios.post(api.showPurchaseOrders, { purchase_order_id: id }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            });

            if (response.status === 200) {
                // //console.log(response.data);
                setProducts(response.data)
                // dispatch({
                //     type: 'SHOW_MODAL',
                //     response: response.data,
                //     severity: 'Success'
                // })
                dispatch(ShowLoader('0'))
            }
        } catch (err) {
            dispatch(ShowLoader('0'))
            console.error('Error deleting supplier:', err);
        }
    }

    const handleInputChange = (e) => {
        // //console.log(e.target.value)
        const supplierId = e.target.value.split(',')[0]
        // //console.log(supplierId)
        // return false
        const supplier = suggestions?.find(sup => sup.supplier_id == supplierId);
        setSelectedSupplier(supplier)
        
        const suppLoanAmount = suplierLoans.filter((it) => it.supplier_id == supplierId) 
        setshowSupplier(suppLoanAmount[0])
        // //console.log(suppLoanAmount)
        // supplier.loanAmount = suppLoanAmount
        
        const totalBilledAmount = supplier.purchase_orders.reduce((sum, order) => sum + order.total_amount, 0);
        // //console.log(supplier)
        // Sum up amount_out from all payments across all purchase orders
        // const totalLoan = supplier.purchase_orders
        //     .flatMap(order => order.payments) // Extract payments arrays
        //     .reduce((sum, payment) => sum + (payment?.amount_out || 0), 0); // Sum up amount_out values

        // //console.log(totalPurchaseAmount, totalPaymentMade)
        setTotalUnpaid(suppLoanAmount)
        setTotalBilled(totalBilledAmount)


        // return { totalPurchaseAmount, totalPaymentMade };
    }

    const catchInOut = (catchVal) => {
        // //console.log(catchVal)
        setCurrentSupplierPayInOut(catchVal)
    }

    const returnProduct = async (returnProd) => {
        dispatch(ShowLoader('1'))
        returnProd.supplierId = selectedSupplier.supplier_id
        returnProd.supplier_name = selectedSupplier.supplier_name 
        const userToken = JSON.parse(localStorage.getItem("User_Data"))?.token || undefined;
        const isAjustReq = ((parseFloat(returnProd.amount) > parseFloat(showSupplier.amount_remaining)) && parseFloat(showSupplier.amount_remaining) !== 0 )
        const remainingAm =  parseFloat(showSupplier.amount_remaining)//60 - 10
        if(parseFloat(showSupplier.amount_remaining) >= parseFloat(returnProd.amount)){
            // returnProd.amount = showSupplier.amount_remaining
            returnProd.payReceive = 'No'
        }
        try {
            const response = await axios.post(api.returnBack, returnProd, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userToken}`,
                },
            });
            if (response.status === 200) {
                // //console.log(response.data)
                if(isAjustReq){
                    const payLoad = {adjustAmount : remainingAm, supplierId:selectedSupplier.supplier_id, supplier_name: selectedSupplier.supplier_name,  pOrderId: returnProd.pOrderId}
                    returnAdjustment(payLoad)
                }  
                else{
                    fetchProducts(returnProd.pOrderId);
                    // Explicitly refresh the supplier data
                    await fetchSuppliers();
                    
                    dispatch({
                        type: 'SHOW_MODAL',
                        response: response.data,
                        severity: 'Success'
                    })
                }
                sessionStorage.removeItem('Products');
                dispatch(ShowLoader('0'))
            }
        } catch (err) {
            dispatch(ShowLoader('0'))
            dispatch({
                type: 'SHOW_MODAL',
                response: 'Error',
                severity: 'error'
            })
            console.error("Error fetching suppliers:", err);
        }
    }
    const returnAdjustment = async (payLoad) => {
        const userToken = JSON.parse(localStorage.getItem("User_Data"))?.token || undefined;
        // //console.log(payLoad)
        // return false
        try {
            const response = await axios.post(api.returnBackAdjustment, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${userToken}`,
                },
            });
            if (response.status === 200) {
                // //console.log(response.data)  
                fetchProducts(payLoad.pOrderId);
                 
                await fetchSuppliers();
                
                dispatch({
                    type: 'SHOW_MODAL',
                    response: response.data,
                    severity: 'Success'
                })
            }
        } catch (err) {
            console.error("Error fetching suppliers:", err);
        }
    }

    return (
        <>
            <Grid container>
                <Grid lg={4}>
                </Grid>
                <Grid lg={4}>
                    <SuggestionInput
                        simple="true"
                        handleInputChange={handleInputChange}
                        Suggestions={suggestions}
                        name={data.supplier_name}
                    // onDelete={handleDelete}
                    placeholder=" عرضه کوونکي انتخاب Supplier"

                    />
                </Grid>
                <Grid lg={2}>
                </Grid>
                <Grid lg={2}>
                </Grid>
            </Grid>
            <Grid spacing={2} justifyContent="center">
                {showSupplier?.supplier_name != undefined ? 
                <Grid lg={12}>
                    {/* {showSupplier?.amount_remaining}  `ښاغلی $ پیسې زموږ پوروړې دي ` */}
                    <h2 style={{textAlign: 'center', color: '#f44336'}}>
                    {` ${showSupplier?.supplier_name}پر مونږ باندی [${showSupplier?.amount_remaining}]پورپاته  دي د`}
                    </h2>
                </Grid>
                :null}
            </Grid>

            <Grid container className="updatePrice"> 
                 
                <Grid mt={2} item lg={12}>
                    {selectedSupplier ?
                        <>
                            <Grid container spacing={2} justifyContent="center">
                                <Grid item xs={12}>
                                    {/* <h1 style={{ textAlign: 'right' }}>د بلانو تفصیل</h1> */}
                                </Grid>
                            </Grid>

                            <ReturnTable totalLoan={showSupplier} rows={selectedSupplier?.purchase_orders || []} products={products} callProducts={fetchProducts} returnProd={returnProduct} /> </>
                        : null
                        }
                </Grid>
            </Grid>


            <br />
        </>
    );
};

export default SupplierReturns;

